module.exports = __webpack_public_path__ + "static/fonts/nf.bd04ed53.ttf";